import React, { useEffect } from "react";
import PropTypes from "prop-types";
import { Link } from "react-router-dom";
import {
  List,
  ListItem,
  ListItemIcon,
  ListItemText,
  Drawer,
  IconButton,
  Typography,
  Toolbar
} from "@mui/material";
import { withStyles } from '@mui/styles';
import CloseIcon from "@mui/icons-material/Close";
import { osName, osVersion } from "react-device-detect";

const styles = theme => ({
  closeIcon: {
    marginRight: theme.spacing(1)
  },
  menuIcon: {
    color: theme.palette.primary.main
  },
  closeIcon: {
  },
  header: {
    marginLeft: theme.spacing(2),
    flex: 1,
  },
  noDecoration: {
    textDecoration: "none !important",
    color: theme.palette.getContrastText(theme.palette.background.default)
  }
});

function NavigationDrawer(props) {
  const {
    open,
    onClose,
    anchor,
    classes,
    menuItems,
    selectedItem,
    theme
  } = props;

  return (
    <Drawer variant="temporary" open={open} onClose={onClose} anchor={anchor}>
      {osName === "Android" && Number(osVersion) >= 15 ? <div className="ectool-safe-area-top"></div> : <div className="ectool-safe-area-top"></div>}
      <Toolbar className={classes.headSection}>
        <Typography className={classes.header}> </Typography>
            <IconButton className={classes.closeIcon} onClick={onClose} aria-label="Close Navigation">
              <CloseIcon color="primary" />
            </IconButton>
      </Toolbar>
      <List className={classes.whiteList}>
        {menuItems.map(element => {
          if (element.link) {
            return (
              <Link
                key={element.name}
                to={element.link}
                className={classes.noDecoration}
                onClick={onClose}
              >
                <ListItem
                  button
                  selected={selectedItem === element.name}
                  /**
                   * We disable ripple as it will make a weird animation
                   * with primary and secondary color
                   */
                  disableRipple
                  disableTouchRipple
                >
                  <ListItemIcon className={classes.menuIcon}>{element.icon}</ListItemIcon>
                  <ListItemText
                    primary={
                      <Typography variant="subtitle1">
                        {element.name}
                      </Typography>
                    }
                  />
                </ListItem>
              </Link>
            );
          }
          return (
            <ListItem button key={element.name} onClick={element.onClick}>
              <ListItemIcon className={classes.menuIcon}>{element.icon}</ListItemIcon>
              <ListItemText
                primary={
                  <Typography variant="subtitle1">
                    {element.name}
                  </Typography>
                }
              />
            </ListItem>
          );
        })}
      </List>
    </Drawer>
  );
}

NavigationDrawer.propTypes = {
  anchor: PropTypes.string.isRequired,
  theme: PropTypes.object.isRequired,
  open: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
  menuItems: PropTypes.arrayOf(PropTypes.object).isRequired,
  classes: PropTypes.object.isRequired,
  selectedItem: PropTypes.string
};

export default withStyles(styles, { withTheme: true })(NavigationDrawer);
